import {
	SBBox,
	SBTypography
} from "modules/Commons";
import { useStyles } from "./style";
import clsx from "clsx";

export default (props: SBForecastEvaluationSectionItemValueProps) => {
	const { toCompare, model, value, range, isOnModal, isAverage = false } = props;
	const classes = useStyles();

	return (
		<SBBox display="flex" mt={1}>
			{toCompare ? <SBBox className={clsx(classes.sectionBar, model)} /> : <></>}
			<SBBox display="flex" flexDirection="column" ml={toCompare ? 1 : 0}>
				<SBTypography fontSize="1.25rem" fontWeight="700" variant="h6" color="gray2.main">
					{value}
				</SBTypography>
				{
					!isOnModal || isAverage ?
						<SBTypography fontWeight="600" variant="caption" color="gray3.main" mt={0.5} minHeight="17px">
							{range}
						</SBTypography>
						:
						<></>
				}
			</SBBox>
		</SBBox>
	);
};

interface SBForecastEvaluationSectionItemValueProps {
	toCompare: boolean,
	model: string,
	value: string,
	range: string,
	isOnModal: boolean;
	isAverage?: boolean;
}
